/**
 * Outs Component
 */

import React, { FC } from 'react';
import { OutsProps } from './outs.types';
import { StyledBaseSVG } from './outs.style';
import COLORS from '../../style/universal.color';

const {
  outsYellow,
  outGrey
} = COLORS;

// Retrieve orange for an out, grey for not filled
const retrieveOutFill = (outCount: number, out: number) => {
  return outCount >= out ? outsYellow : outGrey;
}

// Utility function to set active className
const checkActiveClass = (outCount: number, out: number) => {
  return outCount >= out ? { className: 'isOut' } : null
};

const Outs: FC<OutsProps> = ({
    outCount = 0,
    width = 24,
    altText,
    className
  }: OutsProps) => {

  // Size of the circle
  const outSize: number = 2.5;
  // Size of the padding between circles
  const outPadding: number = 5;

  const viewBox: string = `0 0 25 5`;
  const imgAltText: string = altText || `${outCount} outs`;

  // Display the outs as SVG circles.
  return (
    <StyledBaseSVG
      width={ width }
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      className={ className }
      viewBox={ viewBox }
      tabIndex={ -1 } >
        <desc>{ imgAltText }</desc>
        <circle cx={ outSize } cy={ outSize } r={ outSize } fill={ retrieveOutFill(outCount, 1) } { ...checkActiveClass(outCount, 1) } />
        <circle cx={ outSize * 3 + outPadding } cy={ outSize } r={ outSize } fill={ retrieveOutFill(outCount, 2) } { ...checkActiveClass(outCount, 2) } />
        <circle cx={ outSize * 5 + outPadding * 2} cy={ outSize } r={ outSize } fill={ retrieveOutFill(outCount, 3) } { ...checkActiveClass(outCount, 3) } />
    </StyledBaseSVG>
  );
};

export default Outs;
